import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
} from '@chakra-ui/react'
import React from 'react'

export const DeleteUserModal = ({
  isOpen,
  onClose,
  onDelete,
  isLoading,
  isDisabled,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete User</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>Are you sure you want to delete this user?</Text>
          <Text fontSize='sm' color='red.500' mt={2}>
            This action cannot be undone.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme='red'
            onClick={onDelete}
            isLoading={isLoading}
            isDisabled={isDisabled}
            type='submit'
          >
            Delete
          </Button>
          <Button ml={3} colorScheme='gray' onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
